import type { FC } from 'react';
import { Lesson } from '@/Module/Lesson/Component';
import { lessonSelectIds } from '@/Module/Lesson/Store/Selector';
import { useAppSelector } from '@/Module/Store/Hook';
const LessonList: FC = () => {
  const ids = useAppSelector(lessonSelectIds);

  // TODO implement empty list
  if (!ids.length) return null;
  return <div className="mb-9 grid grid-cols-2 gap-6 sm:grid-cols-3 lg:mb-20 lg:grid-cols-4 xl:grid-cols-5 xl:gap-10" data-sentry-component="LessonList" data-sentry-source-file="LessonList.tsx">
      {ids.map(id => <Lesson id={id} key={id} />)}
    </div>;
};
export default LessonList;